export default __webpack_public_path__ + "static/media/image 37.0f9c459a.png";